import React, { useState } from 'react';
import { Mail, Reply, Trash2, CheckCircle, Search, AlertCircle } from 'lucide-react';

const MessagesTab = ({
  messages,
  handleMarkAsRead,
  handleReply,
  handleClearAllMessages,
  formatDate
}) => {
  const [filterStatus, setFilterStatus] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredMessages = messages.filter((msg) => {
    const matchesStatus =
      filterStatus === 'all'
        ? true
        : filterStatus === 'unread'
        ? msg.status === 'unread' || !msg.status
        : msg.status === filterStatus;

    const q = searchQuery.toLowerCase();
    const matchesSearch =
      (msg.name && msg.name.toLowerCase().includes(q)) ||
      (msg.email && msg.email.toLowerCase().includes(q)) ||
      (msg.subject && msg.subject.toLowerCase().includes(q)) ||
      (msg.message && msg.message.toLowerCase().includes(q));

    return matchesStatus && matchesSearch;
  });

  return (
    <div className="tab-pane messages-pane">
      {/* Inbox Controls Bar */}
      <div className="inbox-controls-bar">
        <div className="inbox-left">
          <div className="search-box">
            <Search className="search-icon" />
            <input
              type="text"
              placeholder="Search sender, email, subject or message..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
          </div>

          <div className="filter-pill-group">
            <button
              className={`filter-pill ${filterStatus === 'all' ? 'active' : ''}`}
              onClick={() => setFilterStatus('all')}
            >
              ALL ({messages.length})
            </button>
            <button
              className={`filter-pill ${filterStatus === 'unread' ? 'active' : ''}`}
              onClick={() => setFilterStatus('unread')}
            >
              UNREAD ({messages.filter((m) => m.status === 'unread' || !m.status).length})
            </button>
            <button
              className={`filter-pill ${filterStatus === 'replied' ? 'active' : ''}`}
              onClick={() => setFilterStatus('replied')}
            >
              REPLIED ({messages.filter((m) => m.status === 'replied').length})
            </button>
          </div>
        </div>

        <div className="inbox-right">
          {messages.length > 0 && (
            <button className="admin-action-btn danger-btn" onClick={handleClearAllMessages}>
              <Trash2 size={14} />
              <span>CLEAR ALL MESSAGES</span>
            </button>
          )}
        </div>
      </div>

      {/* Messages List */}
      <div className="messages-list-container">
        {filteredMessages.length === 0 ? (
          <div className="empty-state-card">
            <AlertCircle size={32} className="empty-icon" />
            <p>No contact messages match your current filter settings.</p>
          </div>
        ) : (
          filteredMessages.map((msg) => {
            const isUnread = !msg.status || msg.status === 'unread';

            return (
              <div key={msg._id} className={`message-card ${isUnread ? 'unread' : ''}`}>
                <div className="msg-header">
                  <div className="sender-info">
                    <div className="sender-avatar">{msg.name?.charAt(0)?.toUpperCase() || 'U'}</div>
                    <div className="sender-details">
                      <h4 className="sender-name">{msg.name}</h4>
                      <a href={`mailto:${msg.email}`} className="sender-email">
                        {msg.email}
                      </a>
                    </div>
                  </div>

                  <div className="msg-meta">
                    <span className={`status-badge ${msg.status || 'unread'}`}>
                      {msg.status?.toUpperCase() || 'UNREAD'}
                    </span>
                    <span className="msg-date">{formatDate(msg.createdAt)}</span>
                  </div>
                </div>

                <div className="msg-body">
                  <h5 className="msg-subject-title">{msg.subject || 'No Subject'}</h5>
                  <p className="msg-full-text">{msg.message}</p>
                </div>

                <div className="msg-actions-bar">
                  {isUnread && (
                    <button
                      className="msg-btn mark-read-btn"
                      onClick={(e) => handleMarkAsRead(msg._id, e)}
                    >
                      <CheckCircle size={14} />
                      <span>MARK AS READ</span>
                    </button>
                  )}

                  <button className="msg-btn reply-btn" onClick={() => handleReply(msg)}>
                    <Reply size={14} />
                    <span>REPLY VIA EMAIL</span>
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default MessagesTab;
